import { render, staticRenderFns } from "./SupportTopic.vue?vue&type=template&id=41a8487a&"
import script from "./SupportTopic.vue?vue&type=script&lang=js&"
export * from "./SupportTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports